import { useQuery } from 'react-query'

import { TrackedChange } from 'types'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { trackedChangesKeys } from './trackedChangesKeys'
import { useArticlePassword } from 'hooks/useArticlePassword'

interface Props {
  articleKey: string
  layerId: string
}

export const useTrackedChanges = ({ articleKey, layerId }: Props) => {
  const password = useArticlePassword(articleKey)

  return useQuery<{ tracked_changes: TrackedChange[] }, Error>(
    trackedChangesKeys.list(layerId, { password }),
    async () => {
      const response = await sendToApi<{ tracked_changes: [] }>(`/articles/${articleKey}/layers/${layerId}/changes`, {
        method: 'GET',
        params: { password },
      })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }

      return response.data
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  )
}
